import { Component } from '@angular/core';

@Component({
    selector: 'app-outputs-edit-container',
    templateUrl: './outputs-edit-container.component.html',
    styleUrls: ['./outputs-edit-container.component.scss'],
    standalone: false
})
export class OutputsEditContainerComponent {

}
